var _style, _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainfunnel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 779,
    xmlns: "http://www.w3.org/2000/svg",
    height: 795.402,
    id: "screenshot-823d426d-c4ea-8096-8005-2b19128c8be2",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "@font-face{font-family:&apos;Lato&apos;;font-style:normal;font-weight:400;font-display:block;src:url(https://design.penpot.app/internal/gfonts/font/lato/v24/S6uyw4BMUTPHjxAwXjeu.woff2) format(&apos;woff2&apos;);unicode-range:U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF}@font-face{font-family:&apos;Lato&apos;;font-style:normal;font-weight:400;font-display:block;src:url(https://design.penpot.app/internal/gfonts/font/lato/v24/S6uyw4BMUTPHjx4wXg.woff2) format(&apos;woff2&apos;);unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD}")), /*#__PURE__*/React.createElement("g", {
    id: "shape-823d426d-c4ea-8096-8005-2b19128c8be2",
    "data-testid": "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-823d426d-c4ea-8096-8005-2b18d1c05999",
    "data-testid": "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-823d426d-c4ea-8096-8005-2b171f6e9c68",
    "data-testid": "Rectangle"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278 561h185.337l-31.568 59.832H308.55L278 561Z",
    style: {
      fill: "rgb(93, 197, 110)",
      fillOpacity: 1
    },
    className: "fills",
    id: "fills-823d426d-c4ea-8096-8005-2b171f6e9c68"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shape-823d426d-c4ea-8096-8005-2b171f6e9c69",
    "data-testid": "Rectangle"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221 472h298.973l-50.924 77.77H270.281L221 472Z",
    style: {
      fill: "rgb(93, 197, 110)",
      fillOpacity: 1
    },
    className: "fills",
    id: "fills-823d426d-c4ea-8096-8005-2b171f6e9c69"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shape-823d426d-c4ea-8096-8005-2b171f6e9c6a",
    "data-testid": "Rectangle"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310 633h118.922L426.7 745.08 310 795.402V633Z",
    style: {
      fill: "rgb(93, 197, 110)",
      fillOpacity: 1
    },
    className: "fills",
    id: "fills-823d426d-c4ea-8096-8005-2b171f6e9c6a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shape-823d426d-c4ea-8096-8005-2b171f6e9c6b",
    "data-testid": "Rectangle"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103 484h495.695H103Z",
    style: {
      fill: "rgb(177, 178, 181)",
      fillOpacity: 1
    },
    className: "fills",
    id: "fills-823d426d-c4ea-8096-8005-2b171f6e9c6b"
  })), /*#__PURE__*/React.createElement("g", {
    className: "text-container",
    id: "shape-823d426d-c4ea-8096-8005-2b171f6e9c6c",
    "data-testid": "Extract data"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    patternUnits: "userSpaceOnUse",
    x: 221,
    y: 472,
    width: 186.488,
    height: 41.6,
    id: "fill-0-render-7-0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 186.488,
    height: 41.6,
    style: {
      fill: "rgb(255, 255, 255)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("text", {
    x: 277.237,
    y: 531.475,
    dominantBaseline: "ideographic",
    textLength: 186.488,
    lengthAdjust: "spacingAndGlyphs",
    style: {
      textTransform: "none",
      fontFamily: "Lato",
      letterSpacing: "normal",
      fontStyle: "normal",
      fontWeight: 400,
      whiteSpace: "pre",
      fontSize: 35,
      textDecoration: "none solid rgb(255, 255, 255)",
      direction: "ltr",
      fill: "rgb(255, 255, 255)",
      fillOpacity: 1
    },
    className: "fills",
    id: "fills-823d426d-c4ea-8096-8005-2b171f6e9c6c"
  }, "Extract data")), /*#__PURE__*/React.createElement("g", {
    className: "text-container",
    id: "shape-823d426d-c4ea-8096-8005-2b171f6e9c6d",
    "data-testid": "In"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    patternUnits: "userSpaceOnUse",
    x: 278,
    y: 561,
    width: 30.212,
    height: 41.6,
    id: "fill-0-render-8-0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.212,
    height: 41.6,
    style: {
      fill: "rgb(255, 255, 255)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("text", {
    x: 355.138,
    y: 611.9,
    dominantBaseline: "ideographic",
    textLength: 30.212,
    lengthAdjust: "spacingAndGlyphs",
    style: {
      textTransform: "none",
      fontFamily: "Lato",
      letterSpacing: "normal",
      fontStyle: "normal",
      fontWeight: 400,
      whiteSpace: "pre",
      fontSize: 35,
      textDecoration: "none solid rgb(255, 255, 255)",
      direction: "ltr",
      fill: "rgb(255, 255, 255)",
      fillOpacity: 1
    },
    className: "fills",
    id: "fills-823d426d-c4ea-8096-8005-2b171f6e9c6d"
  }, "In")), /*#__PURE__*/React.createElement("g", {
    className: "text-container",
    id: "shape-823d426d-c4ea-8096-8005-2b171f6e9c6e",
    "data-testid": "One click"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    patternUnits: "userSpaceOnUse",
    x: 310,
    y: 634,
    width: 68.95,
    height: 83.6,
    id: "fill-0-render-9-0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68.95,
    height: 83.6,
    style: {
      fill: "rgb(255, 255, 255)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("pattern", {
    patternUnits: "userSpaceOnUse",
    x: 310,
    y: 634,
    width: 68.95,
    height: 83.6,
    id: "fill-1-render-9-0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68.95,
    height: 83.6,
    style: {
      fill: "rgb(255, 255, 255)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("text", {
    x: 336.587,
    y: 688.487,
    dominantBaseline: "ideographic",
    textLength: 65.738,
    lengthAdjust: "spacingAndGlyphs",
    style: {
      textTransform: "none",
      fontFamily: "Lato",
      letterSpacing: "normal",
      fontStyle: "normal",
      fontWeight: 400,
      whiteSpace: "pre",
      fontSize: 35,
      textDecoration: "none solid rgb(255, 255, 255)",
      direction: "ltr",
      fill: "rgb(255, 255, 255)",
      fillOpacity: 1
    },
    className: "fills",
    id: "fills-823d426d-c4ea-8096-8005-2b171f6e9c6e"
  }, "One"), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    patternUnits: "userSpaceOnUse",
    x: 310,
    y: 634,
    width: 68.95,
    height: 83.6,
    id: "fill-0-render-9-1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68.95,
    height: 83.6,
    style: {
      fill: "rgb(255, 255, 255)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("pattern", {
    patternUnits: "userSpaceOnUse",
    x: 310,
    y: 634,
    width: 68.95,
    height: 83.6,
    id: "fill-1-render-9-1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68.95,
    height: 83.6,
    style: {
      fill: "rgb(255, 255, 255)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("text", {
    x: 334.975,
    y: 730.488,
    dominantBaseline: "ideographic",
    textLength: 68.95,
    lengthAdjust: "spacingAndGlyphs",
    style: {
      textTransform: "none",
      fontFamily: "Lato",
      letterSpacing: "normal",
      fontStyle: "normal",
      fontWeight: 400,
      whiteSpace: "pre",
      fontSize: 35,
      textDecoration: "none solid rgb(255, 255, 255)",
      direction: "ltr",
      fill: "rgb(255, 255, 255)",
      fillOpacity: 1
    },
    className: "fills"
  }, "click")), /*#__PURE__*/React.createElement("g", {
    id: "shape-823d426d-c4ea-8096-8005-2b171f6e9c5d",
    "data-testid": "Rectangle"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h779L529.038 455.184H212.282L0 0Z",
    style: {
      fill: "rgb(200, 209, 234)",
      fillOpacity: 0.65
    },
    className: "fills",
    id: "fills-823d426d-c4ea-8096-8005-2b171f6e9c5d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shape-823d426d-c4ea-8096-8005-2b171f6e9c5e",
    "data-testid": "Ellipse"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 168.8,
    cy: 107.057,
    rx: 77.8,
    ry: 80.057,
    style: {
      fill: "rgb(197, 226, 197)",
      fillOpacity: 1
    },
    className: "fills",
    id: "fills-823d426d-c4ea-8096-8005-2b171f6e9c5e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shape-823d426d-c4ea-8096-8005-2b171f6e9c5f",
    "data-testid": "Ellipse"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 629.8,
    cy: 100.057,
    rx: 77.8,
    ry: 80.057,
    style: {
      fill: "rgb(197, 226, 197)",
      fillOpacity: 1
    },
    className: "fills",
    id: "fills-823d426d-c4ea-8096-8005-2b171f6e9c5f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shape-823d426d-c4ea-8096-8005-2b171f6e9c60",
    "data-testid": "Ellipse"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 463.8,
    cy: 343.057,
    rx: 77.8,
    ry: 80.057,
    style: {
      fill: "rgb(197, 226, 197)",
      fillOpacity: 1
    },
    className: "fills",
    id: "fills-823d426d-c4ea-8096-8005-2b171f6e9c60"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shape-823d426d-c4ea-8096-8005-2b171f6e9c61",
    "data-testid": "Ellipse"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 431.8,
    cy: 149.057,
    rx: 77.8,
    ry: 80.057,
    style: {
      fill: "rgb(94, 129, 230)",
      fillOpacity: 1
    },
    className: "fills",
    id: "fills-823d426d-c4ea-8096-8005-2b171f6e9c61"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shape-823d426d-c4ea-8096-8005-2b171f6e9c62",
    "data-testid": "Ellipse"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 270.8,
    cy: 287.057,
    rx: 77.8,
    ry: 80.057,
    style: {
      fill: "rgb(94, 129, 230)",
      fillOpacity: 0.5
    },
    className: "fills",
    id: "fills-823d426d-c4ea-8096-8005-2b171f6e9c62"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shape-823d426d-c4ea-8096-8005-2b171f6e9c63",
    "data-testid": "NAUKRI_LOGO-removebg-preview"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    patternUnits: "userSpaceOnUse",
    x: 109,
    y: 42,
    width: 120.034,
    height: 134.954,
    id: "fill-0-render-16"
  }, /*#__PURE__*/React.createElement("image", {
    id: "fill-image-render-16-0",
    href: "https://design.penpot.app/assets/by-file-media-id/5e250d03-b345-8112-8005-2b171ea7d5fc",
    preserveAspectRatio: "xMidYMid slice",
    width: 120.034,
    height: 134.954,
    opacity: 1
  }))), /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 109,
    y: 42,
    width: 120.034,
    height: 134.954,
    fill: "url(#fill-0-render-16)",
    className: "fills",
    id: "fills-823d426d-c4ea-8096-8005-2b171f6e9c63"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "shape-823d426d-c4ea-8096-8005-2b171f6e9c64",
    "data-testid": "linkedin-logo-linkedin-symbol-linkedin-icon-free-free-vector-removebg-preview"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    patternUnits: "userSpaceOnUse",
    x: 386,
    y: 263,
    width: 155.599,
    height: 160.115,
    id: "fill-0-render-17"
  }, /*#__PURE__*/React.createElement("image", {
    id: "fill-image-render-17-0",
    href: "https://design.penpot.app/assets/by-file-media-id/9cff1166-2265-80f2-8005-2b171eb93424",
    preserveAspectRatio: "xMidYMid slice",
    width: 155.599,
    height: 160.115,
    opacity: 1
  }))), /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 386,
    y: 263,
    width: 155.599,
    height: 160.115,
    fill: "url(#fill-0-render-17)",
    className: "fills",
    id: "fills-823d426d-c4ea-8096-8005-2b171f6e9c64"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "shape-823d426d-c4ea-8096-8005-2b171f6e9c65",
    "data-testid": "png-transparent-github-computer-icons-gitlab-github-white-cat-like-mammal-carnivoran-removebg-preview"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    patternUnits: "userSpaceOnUse",
    x: 376,
    y: 93,
    width: 111.142,
    height: 114.368,
    id: "fill-0-render-18"
  }, /*#__PURE__*/React.createElement("image", {
    id: "fill-image-render-18-0",
    href: "https://design.penpot.app/assets/by-file-media-id/5e250d03-b345-8112-8005-2b171ebf04ff",
    preserveAspectRatio: "xMidYMid slice",
    width: 111.142,
    height: 114.368,
    opacity: 1
  }))), /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 376,
    y: 93,
    width: 111.142,
    height: 114.368,
    fill: "url(#fill-0-render-18)",
    className: "fills",
    id: "fills-823d426d-c4ea-8096-8005-2b171f6e9c65"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "shape-823d426d-c4ea-8096-8005-2b171f6e9c66",
    "data-testid": "image"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    patternUnits: "userSpaceOnUse",
    x: 229,
    y: 247,
    width: 84.468,
    height: 86.92,
    id: "fill-0-render-19"
  }, /*#__PURE__*/React.createElement("image", {
    id: "fill-image-render-19-0",
    href: "https://design.penpot.app/assets/by-file-media-id/9cff1166-2265-80f2-8005-2b171ef4684e",
    preserveAspectRatio: "xMidYMid slice",
    width: 84.468,
    height: 86.92,
    opacity: 1
  }))), /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 229,
    y: 247,
    width: 84.468,
    height: 86.92,
    fill: "url(#fill-0-render-19)",
    className: "fills",
    id: "fills-823d426d-c4ea-8096-8005-2b171f6e9c66"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "shape-823d426d-c4ea-8096-8005-2b171f6e9c67",
    "data-testid": "2064841-removebg-preview"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    patternUnits: "userSpaceOnUse",
    x: 587,
    y: 57,
    width: 93.36,
    height: 80.057,
    id: "fill-0-render-20"
  }, /*#__PURE__*/React.createElement("image", {
    id: "fill-image-render-20-0",
    href: "https://design.penpot.app/assets/by-file-media-id/5e250d03-b345-8112-8005-2b171f364e45",
    preserveAspectRatio: "xMidYMid slice",
    width: 93.36,
    height: 80.057,
    opacity: 1
  }))), /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 587,
    y: 57,
    width: 93.36,
    height: 80.057,
    fill: "url(#fill-0-render-20)",
    className: "fills",
    id: "fills-823d426d-c4ea-8096-8005-2b171f6e9c67"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainfunnel);
export default __webpack_public_path__ + "static/media/mainfunnel.fc6dd1160d6ae1de0173a1a653992e6a.svg";
export { ForwardRef as ReactComponent };